import React, {Component} from 'react';
import './Subsection.less';

class Subsection extends Component {
    fireEdapEvent = (e) => {
        const {cta} = this.props;
        this.props.edapHandler(cta);
    };

    render() {
        const {headline, copy, cta} = this.props;
        const url = cta ? cta.url : false;
        return (
            <article className="Subsection">
                <h4>{headline}</h4>
                <p>{copy}</p>
                {url.length > 0 && (
                    <a
                        href={cta.url}
                        target="_blank"
                        rel="noreferrer"
                        onClick={this.fireEdapEvent}
                    >
                        {cta.label}
                    </a>
                )}
            </article>
        );
    }
}

export default Subsection;
